export function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
    }
  }
  return fmt
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length)
}

/**
 * Created by jiachenpan on 16/11/18.
 */
export function getLastC2CHistoryMsgs(cbOk, cbError) {
  let that = this;
  if(that.selToID == undefined)
    return;
  var selType = webim.SESSION_TYPE.C2C
  var lastMsgTime = 0; //第一次拉取好友历史消息时，必须传0
  var msgKey = '';
  var account = '';
  account += that.selToID;
  var options = {
    'Peer_Account': account, //好友帐号
    'MaxCnt': 3, //拉取消息条数
    'LastMsgTime': lastMsgTime, //最近的消息时间，即从这个时间点向前拉取历史消息
    'MsgKey': msgKey
  };
  var selSess = null;
  webim.MsgStore.delSessByTypeId(selType, account);

  webim.getC2CHistoryMsgs(
    options,
    function(resp) {
      var complete = resp.Complete; //是否还有历史消息可以拉取，1-表示没有，0-表示有
      var getPrePageC2CHistroyMsgInfoMap = {}; //保留下一次拉取好友历史消息的信息
      if(resp.MsgList.length == 0) {
        var messageList = []
        that.setMessages(messageList);
        webim.Log.warn("没有历史消息了:data=" + JSON.stringify(options));
        return;
      }
      getPrePageC2CHistroyMsgInfoMap[account] = { //保留服务器返回的最近消息时间和消息Key,用于下次向前拉取历史消息
        'LastMsgTime': resp.LastMsgTime,
        'MsgKey': resp.MsgKey
      };
      if(cbOk)
        cbOk(resp.MsgList);
    },
    cbError
  );
}

export function parseTime(time, cFormat) {
  if(arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if(typeof time === 'object') {
    date = time
  } else {
    if(('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if(key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if(result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if(diff < 30) {
    return '刚刚'
  } else if(diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if(diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if(diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if(option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
  }
}

// 格式化时间
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 *get getByteLen
 * @param {Sting} val input value
 * @returns {number} output value
 */
export function getByteLen(val) {
  let len = 0
  for(let i = 0; i < val.length; i++) {
    if(val[i].match(/[^\x00-\xff]/ig) != null) {
      len += 1
    } else {
      len += 0.5
    }
  }
  return Math.floor(len)
}

export function cleanArray(actual) {
  const newArray = []
  for(let i = 0; i < actual.length; i++) {
    if(actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

export function param(json) {
  if(!json) return ''
  return cleanArray(Object.keys(json).map(key => {
    if(json[key] === undefined) return ''
    return encodeURIComponent(key) + '=' +
      encodeURIComponent(json[key])
  })).join('&')
}

export function param2Obj(url) {
  const search = url.split('?')[1]
  if(!search) {
    return {}
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
}

export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

export function objectMerge(target, source) {
  /* Merges two  objects,
   giving the last one precedence */

  if(typeof target !== 'object') {
    target = {}
  }
  if(Array.isArray(source)) {
    return source.slice()
  }
  for(const property in source) {
    if(source.hasOwnProperty(property)) {
      const sourceProperty = source[property]
      if(typeof sourceProperty === 'object') {
        target[property] = objectMerge(target[property], sourceProperty)
        continue
      }
      target[property] = sourceProperty
    }
  }
  return target
}

export function scrollTo(element, to, duration) {
  if(duration <= 0) return
  const difference = to - element.scrollTop
  const perTick = difference / duration * 10
  setTimeout(() => {
    // console.log(new Date())
    element.scrollTop = element.scrollTop + perTick
    if(element.scrollTop === to) return
    scrollTo(element, to, duration - 10)
  }, 10)
}

export function toggleClass(element, className) {
  if(!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if(nameIndex === -1) {
    classString += '' + className
  } else {
    classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

export const pickerOptions = [{
  text: '今天',
  onClick(picker) {
    const end = new Date()
    const start = new Date(new Date().toDateString())
    end.setTime(start.getTime())
    picker.$emit('pick', [start, end])
  }
}, {
  text: '最近一周',
  onClick(picker) {
    const end = new Date(new Date().toDateString())
    const start = new Date()
    start.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
    picker.$emit('pick', [start, end])
  }
}, {
  text: '最近一个月',
  onClick(picker) {
    const end = new Date(new Date().toDateString())
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
    picker.$emit('pick', [start, end])
  }
}, {
  text: '最近三个月',
  onClick(picker) {
    const end = new Date(new Date().toDateString())
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
    picker.$emit('pick', [start, end])
  }
}]

export function getTime(type) {
  if(type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if(last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if(!immediate) {
        result = func.apply(context, args)
        if(!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if(!timeout) timeout = setTimeout(later, wait)
    if(callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

export function deepClone(source) {
  if(!source && typeof source !== 'object') {
    throw new Error('error arguments', 'shallowClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  for(const keys in source) {
    if(source.hasOwnProperty(keys)) {
      if(source[keys] && typeof source[keys] === 'object') {
        targetObj[keys] = source[keys].constructor === Array ? [] : {}
        targetObj[keys] = deepClone(source[keys])
      } else {
        targetObj[keys] = source[keys]
      }
    }
  }
  return targetObj
}

export function getCookie(cookie_name) {
  var allcookies = document.cookie;
  var cookie_pos = allcookies.indexOf(cookie_name); //索引的长度

  // 如果找到了索引，就代表cookie存在，
  // 反之，就说明不存在。
  if(cookie_pos != -1) {
    // 把cookie_pos放在值的开始，只要给值加1即可。
    cookie_pos += cookie_name.length + 1; //这里容易出问题，所以请大家参考的时候自己好好研究一下
    var cookie_end = allcookies.indexOf(";", cookie_pos);

    if(cookie_end == -1) {
      cookie_end = allcookies.length;
    }

    var value = unescape(allcookies.substring(cookie_pos, cookie_end)); //这里就可以得到你想要的cookie的值了。。。
  }
  return value;
}

//判断权限数组中是否包含指定权限   permission：A读 B读写   permissionsList：用户某一模块的权限
export function handlePermission(permission, permissionsList) {
  let flag = false
  for(let index=0;index < permissionsList.length;index++){
    let item = permissionsList[index];
    // 判断用户权限中是否包含指定权限
    if (item.indexOf(permission) != -1) {
      flag = true
      break;
    }
  }
  return flag;
}

//权限组装为二维数组  [[A1,B2],[],[]]  其中[A1,B2] 为A0模块的读个人和读写全部
export function getHandledPermissionList(permissionsList) {
  const arr = ['A0', 'A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'A7', 'A8', 'A9', 'B0', 'B1', 'B2']
  const jurisdictionList = [
    []
  ]
  for (let i = 0; i < permissionsList.length; i++) {
    var item = permissionsList[i];
    //权限的前两位 即代表模块名  A0 A1 等
    var itemFront = item.substr(0,2);
    //权限的前两位 即代表权限名  A1  A2  B1  B2
    var itemBehind = item.substr(2);
    for (let index = 0; index < arr.length; index++) {
      if (jurisdictionList[index] == undefined) {
        jurisdictionList[index] = []
      }
      if (itemFront.indexOf(arr[index]) != -1) {
        var length = jurisdictionList[index].length
        jurisdictionList[index][length] = itemBehind
        break;
      }
    }
  }
  sessionStorage.setItem("jurisdictionArray", JSON.stringify(jurisdictionList))
}

export function makeNumber(num) {
  if(num == "" || num == null) {
    return 0;
  }
  var number = num.toString();
  var state = 0;
  if(number.indexOf("-") != -1) {
    num = number.substring(1, num.length);
    state = 1;
  }
  var result = "";
  num = Number(num.toString() || 0).toFixed(2);
  var numAry = num.toString().split(".");
  var preNum = numAry[0];
  var lastNum = numAry[1];

  while(preNum.length > 3) {
    result = "," + preNum.slice(-3) + result;
    preNum = preNum.slice(0, preNum.length - 3);
  }
  if(preNum) {
    result = preNum + result;
  }
  result = result + "." + lastNum;
  if(state == 1) {
    result = "-" + result;
  }

  return result;
}

export function reTime(value) {
  if(value == null || value == '') {
    return ''
  } else {
    return value.substr(0, 10);
  }
}
export function reTime2(value) {
  if(value == null || value == '') {
    return ''
  } else {
    return value.substr(0, 4);
  }
}
export function reTime3(value) {
  if(value == null || value == '') {
    return ''
  } else {
    return value.substr(5, 5);
  }
}
export function reTimes(value) {
  if(value == null || value == '') {
    return ''
  } else {
    return value.substr(10, 10);
  }
}
export function lessMiao(time) {
  if(time == null || time == '') {
    return ''
  } else {
    var now = new String(time);
    return now.substr(0, now.length - 3);
  }
}
////字符串转换
export function toNumber(value){
  return value+''

}
////字符串转换
export function isNumber(value){
  return parseInt(value)

}
////字符串截取
export function selectsa(value) {
  return value.slice(0, 20)
}
////字符串截取
export function selecthan(value) {
  if (value.length > 7) {

    return value.slice(0, 7) + '...'

  }else{
    return value
  }


}
////字符串截取
export function selectlvshi(value) {
  if (value.length > 18) {

    return value.slice(0, 18) + '...'

  } else {
    return value
  }


}



// WEBPACK FOOTER //
// ./src/utils/index.js